import React from 'react';
import { Page, Header, Content } from '@backstage/core-components';
import { Card, CardContent, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(3),
  },
}));

export const TechRadarWrapper = () => {
  const classes = useStyles();

  return (
    <Page themeId="tool">
      <Header title="技术雷达" subtitle="技术选型和趋势分析" />
      <Content>
        <div className={classes.container}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                技术雷达功能正在配置中
              </Typography>
              <Typography variant="body1">
                我们正在为您配置技术雷达功能。该功能将帮助您：
              </Typography>
              <Typography variant="body2" component="ul" style={{ marginTop: 16 }}>
                <li>查看组织推荐的技术栈</li>
                <li>了解技术的成熟度和推荐程度</li>
                <li>跟踪技术趋势和变化</li>
                <li>做出明智的技术选择决策</li>
              </Typography>
              <Typography variant="body1" style={{ marginTop: 16 }}>
                敬请期待功能的正式上线！
              </Typography>
            </CardContent>
          </Card>
        </div>
      </Content>
    </Page>
  );
};
